import React from 'react';
import axios from '../axios';
import ModalContentBase from '../modal/hooks/modal_content_base';

const CircleMemberRequest = ({
  join_request_users = {},
  community_header = null,
  circle = {},
}) => {
  const [usersCircles, setUsersCircles] = React.useState(join_request_users);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedReason, setSelectedReason] = React.useState('0');
  const [selectedUsersCircle, setSelectedUsersCircle] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleReasonChange = (e) => {
    setSelectedReason(e.target.value);
  };

  const handleSubmit = async ({ circleId, activationKey, usersCircleId }) => {
    if (selectedReason === '0') return;

    setIsSubmitting(true);

    axios
      .delete(`/api/circle/${circleId}/dismiss/${activationKey}`, {
        data: {
          body: selectedReason,
        },
      })
      .then((response) => {
        const data = response.data;
        window.alert(data.message);
        setUsersCircles((prev) => prev.filter((uc) => uc.id !== usersCircleId));
        setModalOpen(false);
      })
      .catch((error) => {
        window.alert('失敗しました。時間をおいてから、お試しください。');
      })
      .finally(setIsSubmitting(false));
  };

  const handleClick = ({ circleId, activationKey, usersCircleId }) => {
    const confirmed =
      window &&
      window.confirm('承認します。よろしいですか？');
    if (confirmed) {
      axios
        .patch(`/api/circle/${circleId}/participation/${activationKey}`)
        .then((response) => {
          const data = response.data;
          window.alert(data.message);
          setUsersCircles((prev) =>
            prev.filter((uc) => uc.id !== usersCircleId)
          );
          location.reload();
        })
        .catch((error) => {
          window.alert('失敗しました。時間をおいてから、お試しください。');
        });
    }
  };

  return (
    <>
      <ul className="mb-3_5 list-unstyled">
        {usersCircles.map((usersCircle) => (
          <li key={usersCircle.id}>
            <div className="cm-req">
              {/* 1行目: アイコン / 名前・ID / 右端に承認期限 */}
              <div className="cm-req__head">
                <img
                  src={usersCircle.user.avatar_thumb}
                  type="image"
                  className="cm-req__avatar"
                />
                <div className="cm-req__who">
                  {community_header ? (
                    <a
                      href={`/community/${usersCircle.company?.id_to_param}/member/${usersCircle?.companies_user?.member_id}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <p className="cm-req__name">
                        {usersCircle?.company?.is_real_name_required
                          ? usersCircle?.companies_user?.view_full_name_disp
                          : usersCircle?.companies_user?.nickname}
                      </p>
                    </a>
                  ) : (
                    <a
                      href={`/member/profile/${usersCircle.user.member_id}`}
                      style={{ textDecoration: 'none' }}
                    >
                      {/* 本人確認済みのバッジ付きの名前。メンバー一覧の行と同じ表示にそろえる。
                          バッジが無い人は、そのまま名前だけが入る */}
                      <p
                        className="cm-req__name"
                        dangerouslySetInnerHTML={{
                          __html:
                            usersCircle?.fullname_badge_html ||
                            usersCircle?.user?.fullname_disp,
                        }}
                      />
                      <p className="cm-req__id">
                        @{usersCircle?.user?.tunagate_id}
                      </p>
                    </a>
                  )}
                </div>
                {usersCircle.member_application_deadline_format && (
                  <p className="cm-req__deadline">
                    {usersCircle.deadline_tag && (
                      <span
                        className={`cm-req__left cm-req__left--${usersCircle.deadline_tag.level}`}
                      >
                        {usersCircle.deadline_tag.label}
                      </span>
                    )}
                    <span className="cm-req__deadlinetext">
                      {usersCircle.deadline_tag?.level === 'over' ? (
                        // 期限切れは、あと何日かより「いつ申し込まれたものか」が知りたいので
                        // 承認期限のかわりに申請日時を出す
                        <>
                          <span className="cm-req__deadline-label">
                            申請日時：
                          </span>
                          {usersCircle.created_at_format}
                        </>
                      ) : (
                        <>
                          <span className="cm-req__deadline-label">
                            承認期限：
                          </span>
                          {usersCircle.member_application_deadline_format}
                        </>
                      )}
                    </span>
                  </p>
                )}
              </div>
              {/* サークルの質問文は表示しない。
                  質問は「サークルにつき現在の1件」しか保存されておらず、あとから書き換えると
                  過去の申請にも新しい質問が並んで食い違うため。
                  申し込み画面では質問文が入力欄に入った状態で出るので、
                  実際に何を聞かれたかは、この自己紹介文の中に残っている */}
              <div className="cm-req__answer">
                <p className="cm-req__body">{usersCircle.self_introduction}</p>
              </div>
              <div className="cm-req__actions">
                <button
                  type="button"
                  className="a-button a-button__top a-button__top--outline cursor-pointer w-100"
                  style={{ padding: 10 }}
                  onClick={() => {
                    setSelectedUsersCircle(usersCircle);
                    setModalOpen(true);
                  }}
                >
                  却下
                </button>
                <div
                  className="a-button a-button__top a-button--orange w-100"
                  onClick={() =>
                    handleClick({
                      circleId: usersCircle.circle_id,
                      activationKey: usersCircle.activation_key,
                      usersCircleId: usersCircle.id,
                    })
                  }
                >
                  承認
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
      {modalOpen && (
        <ModalContentBase
          closeModal={() => setModalOpen(false)}
          modalContent={
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <p className="text-fw-bold text-center">
                  却下しますか？
                </p>

                <hr />

                <div className="row justify-content-around align-items-center mb-0">
                  <div className="col-3 pl-2 pr-1">
                    <img
                      src={selectedUsersCircle.user?.avatar_thumb}
                      alt=""
                      className="member-icon_48px rounded-circle"
                    />
                  </div>
                  <div className="col-3 pb-2 pl-0">
                    <a
                      href={`/member/profile/${selectedUsersCircle.user?.member_id}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <p className="text-black-333 mb-1_5">
                        {selectedUsersCircle.company?.is_real_name_required
                          ? selectedUsersCircle.user?.view_full_name_disp
                          : selectedUsersCircle.user?.fullname_disp ||
                            selectedUsersCircle.user?.nickname}
                      </p>
                      {!selectedUsersCircle.company && (
                        <p className="mb-0 text-fz-green text-fz-14px line-1">
                          @{selectedUsersCircle.user?.tunagate_id}
                        </p>
                      )}
                    </a>
                  </div>
                  <div className="col-6 p-0 d-flex justify-content-around align-items-center">
                    <p className="line-2 col-11 p-0">
                      {selectedUsersCircle.user?.introduction}
                    </p>
                  </div>
                </div>

                <div className="col-12 p-0 d-flex">
                  <p
                    className="col-10 mb-1 font-weight-bold"
                    style={{
                      fontSize: '13px',
                      padding: '3px',
                      color: '#BBBBBB',
                    }}
                  >
                    {selectedUsersCircle.created_at}
                  </p>
                </div>

                {selectedUsersCircle.circle?.circles_self_introduction_template
                  ?.description && (
                  <div className="col-12 p-0">
                    <p className="text-gray text-fz-14px p-0 mb-0">
                      メンバー申請時の質問：
                      {
                        selectedUsersCircle.circle
                          .circles_self_introduction_template.description
                      }
                    </p>
                  </div>
                )}

                <div className="col-12 p-0">
                  <p className="p-0">{selectedUsersCircle.self_introduction}</p>
                </div>

                <hr />

                <div className="list-group mt20">
                  <p className="mt-2 text-center" style={{ fontWeight: 700 }}>
                    却下の理由
                    <br />
                    （お相手に通知されます）
                  </p>

                  <select
                    className="form-control"
                    value={selectedReason}
                    onChange={handleReasonChange}
                  >
                    <option value="0">選択してください</option>
                    <option value="提供情報が不十分（再申請してほしい）">
                      提供情報が不十分（再申請してほしい）
                    </option>
                    <option value="当サークルの趣旨、条件と合わない">
                      当サークルの趣旨、条件と合わない
                    </option>
                    <option value="メンバー募集を休止している">
                      メンバー募集を休止している
                    </option>
                    <option value="サークル活動を休止している">
                      サークル活動を休止している
                    </option>
                  </select>

                  <button
                    className="a-button a-button__top a-button--orange mx-auto btn-block mt-3 submit-button mb-4"
                    type="button"
                    disabled={selectedReason === '0' || isSubmitting}
                    onClick={() =>
                      handleSubmit({
                        circleId: selectedUsersCircle.circle_id,
                        activationKey: selectedUsersCircle.activation_key,
                        usersCircleId: selectedUsersCircle.id,
                      })
                    }
                  >
                    送信する
                  </button>
                </div>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default CircleMemberRequest;
